import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

// import { PhnxAudioplayer } from './Audioplayer'
// import { AudioplayerProps } from './Audioplayer'

interface AudioplayerBlokProps {
  blok: {
    // title: AudioplayerProps['title']
    mediaLink: any
  } & SbBlokData
}

const Audioplayer: FC<AudioplayerBlokProps> = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)}>
      <iframe
        src={blok.mediaLink as string}
        width="100%"
        height="auto"
        title="media player"
      ></iframe>
    </div>
  )
}

export default Audioplayer
